// extracted by mini-css-extract-plugin
export var statItem = "_ih-1";
export var statsRow = "_ih-0";